export default __webpack_public_path__ + "static/media/tete51.92f08572.png";